import { Pipe, PipeTransform } from '@angular/core';
import { MediaVariantPipe } from './media-variant.pipe';
import { FileRecordDto } from '@careapp-group/ng-sdk';

/**
 * Given a FileRecordDto - return either the record itself (for images)
 * or the thumbnail record (in the case of videos).
 *
 * Should be piped to `filedownloadurl` in order to render.
 */
@Pipe({
    name: 'mediaPreview',
    pure: true,
    standalone: false
})
export class MediaPreviewPipe implements PipeTransform {
  transform(value: FileRecordDto) {
    if (!value) {
      return;
    }

    const variant = new MediaVariantPipe();
    return (
      variant.transform(value, 'purpose', 'videoThumbnail') ||
      variant.transform(value, 'mimeType', 'image/*')
    );
  }
}
